// extracted by mini-css-extract-plugin
export default {"header":"version_header__3P1TX","text":"version_text__HOFTj","btn":"version_btn__9WOOU","img":"version_img__IM1ak"};